// @flow

import React from "react";
import SummaryPanel from "../../components/SummaryPanel";
import { mapPurposeKind, mapSupport, mapFinancingProduct } from "./mappers";

import { PURPOSE_KIND, FINANCING_DEMAND, FINANCING_PRODUCT, FINANCING_SUPPORT } from "./formFields";

type SummaryProps = {
  initialValues: {},
  isEstablishedEntrepreneur: boolean,
  site: "buba" | "bank" | "customer"
};

const Summary = ({ initialValues, isEstablishedEntrepreneur, site }: SummaryProps) => {
  const purposeKind =
    initialValues[PURPOSE_KIND] && initialValues[PURPOSE_KIND].length > 1
      ? "Diverse"
      : mapPurposeKind(initialValues[PURPOSE_KIND][0].kind);
  const productKind =
    initialValues[FINANCING_SUPPORT] || !isEstablishedEntrepreneur
      ? mapSupport(site === "customer")(initialValues[FINANCING_SUPPORT])
      : mapFinancingProduct(initialValues[FINANCING_PRODUCT]);

  return (
    <SummaryPanel
      amount={initialValues[FINANCING_DEMAND]}
      purposeKind={purposeKind}
      productKind={productKind}
    />
  );
};

export default Summary;
